import { render, staticRenderFns } from "./InsMediaGallery.vue?vue&type=template&id=30bc9e12&scoped=true&"
import script from "./InsMediaGallery.vue?vue&type=script&lang=ts&"
export * from "./InsMediaGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ins_media_gallery.scss?vue&type=style&index=0&id=30bc9e12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc9e12",
  null
  
)

export default component.exports